import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class SafraValidation extends DefaultValidation {
	validate(model, refs) {
		let validated = true;

        if (refs.idsafraerpInput.required && Util.isNull(model.idsafraerp)) {
			refs.idsafraerpInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.descricao )) {
			refs.descricaoInput.focusedOut = true;
			validated = false;
		}
		if (Util.isNull(model.datainicial)) {
			refs.datainicialInput.focusedOut = true;
			validated = false;
		}
        
		
        return validated;
    }
}
